import React,{Component} from 'react'
import axios from '../../http-config'
import { connect } from 'react-redux';
import * as actionsCreators from  '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Grid from '@material-ui/core/Grid';
import Card from "./Card/Card.js"
import CardHeader from "./Card/CardHeader.js";
import CardIcon from "./Card/CardIcon.js";
import CardBody from './Card/CardBody.js'
import Button from '@material-ui/core/Button';
import { TextField } from "@material-ui/core";
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
class CardMain extends Component{


  state = {
    filter : {
      'interval':'',
    },
    data:[],
    id:'',
    isDisabled:false,
    interval:'Current Day',
    open:false
  }
  componentDidMount=()=>{
      let payload = {
        token: this.props.token,
        filter: JSON.stringify([this.state.filter]),
        interval:this.state.interval,
        
    }
    let date = new Date()
    let day = date.getDate().toString()<10 ? "0"+date.getDate().toString(): date.getDate().toString()
    let month = (date.getMonth()+1).toString() <10 ? "0"+(date.getMonth()+1).toString(): (date.getMonth()+1).toString()
    let filterDate =  day +'/'+ month+'/' + date.getFullYear().toString()
    localStorage.setItem('filterDate', filterDate);
       this.props.onFetchDashboardData(payload)
       this.props.onFetchClusterData(payload)
    }

    async setFilterByDateField(value){
      let newDate = new Date()
      let currentTimeStamp = newDate.setDate(newDate.getDate())
      let timestampNow = new Date(currentTimeStamp).toLocaleDateString()
      if(value!=null){
        await this.setState({interval: value.title});
        switch(value.title){
          case '7 Days':
              let timeStamplt7 = newDate.setDate(newDate.getDate() - 7)
              let lt7Days = new Date(timeStamplt7).toLocaleDateString()
              localStorage.setItem('filterDate', lt7Days);            
              break;
          case '30 Days':
              let timeStamplt30 = newDate.setDate(newDate.getDate() - 30)
              let lt30Days = new Date(timeStamplt30).toLocaleDateString()
              localStorage.setItem('filterDate', lt30Days);
              break;
          case 'Till Date':
            localStorage.setItem('filterDate', '01/01/2020');
            break;
          default:
            localStorage.setItem('filterDate', timestampNow);
        }
      }else{
        await this.setState({interval: 'Current Day'});
        localStorage.setItem('filterDate', timestampNow);
      }
      let payload = {
        token: this.props.token,
        filter: JSON.stringify([this.state.filter]),
        interval:this.state.interval
    }
      this.props.onFetchDashboardData(payload)
    }
    openPopupCluster =()=>{
      this.setState({open: true})

    }
    handleClose = () => {
      this.setState({ open:false}) ;
    };
  render(){
    let data = !!this.props.data.dashboard_data&&this.props.data.dashboard_data
    let no_of_loads = data?data[0].no_of_loads:0
    let no_of_trucks = data?data[0].no_of_trucks:0
    
    return(
      <div>
      <Grid container spacing={2} >
        <Grid item xs={3}>
          <Card>
            <hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr>  
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <BusinessOutlinedIcon />
              </CardIcon> 
                <CardBody>
                    <h2  style ={{color: "#3dab35",fontSize: "35px",minHeight: "5px",fontWeight: "1000",marginBottom: "10px"}} align="left">{no_of_loads}</h2>
                    <h2  style = {{color:"black",fontSize:"20px"}} align="left">Loads</h2>
                </CardBody>          
            </CardHeader> 
          </Card>
        </Grid>   
        <Grid item xs={3}>
          <Card>
            <CardHeader color="warning" stats icon>
               <hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr>
               <CardIcon color="warning">
                 <LocalShippingOutlinedIcon  />
               </CardIcon> 
                 <CardBody>
                    <h2 style = {{color: "#3dab35",fontSize: "35px",minHeight: "5px",fontWeight: "1000",marginBottom: "10px"}} align="left">{no_of_trucks}</h2>
                    <h2 style = {{color:"black",fontSize:"20px"}}  align="left">Trucks</h2>
                 </CardBody>  
            </CardHeader>
           </Card>
        </Grid>
        <Grid item xs={6}>
           <Card>
             <CardHeader stats icon>
              <hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr>
              <h2 style={{color:"#3DAB35",fontSize:"20px",paddingTop: "10px"}} align="left">Filter By</h2>
             </CardHeader>
               <CardBody>
                  <Grid container spacing={0} direction="row">
                    <Grid item xs={6}>
                     
                      <h2  style = {{fontSize:"12px", marginBottom: "4%" , marginLeft:"1%", marginRight:"5%", textAlign:'left' }}>Days</h2>
                       <Autocomplete
                          style = {{width: '100%', fontSize:"10px"}}
                          value={this.state.interval==undefined ? 'Current Day':this.state.interval}
                          onChange={(event, value) => this.setFilterByDateField(value)}
                          id="combo-box-demo"
                          options={[{title:"Current Day"},{title:"7 Days"},{title:"30 Days"},{title:"Till Date"}]}
                          getOptionLabel={option => typeof option === 'string' ? option : option.title}
                          renderInput={(params) => <TextField {...params} style = {{width: '100%', fontSize:"12px"}} placeholder="Select" size="small" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={6}>
                      <h2 style = {{fontSize:"12px", marginBottom: "4%" , marginLeft:"5%", textAlign:'left' }}>Date</h2>
                      <TextField  id="filterDate" disabled style = {{width: '100%', marginLeft:"5%", fontSize:"12px"}} size="small"  variant="outlined" value={localStorage.getItem('filterDate')}  type="text" />
                    </Grid>
                  </Grid>
               </CardBody>
           </Card>
        </Grid>
        {/* <Grid item xs={2}>
          <Card>
            <CardHeader>
               <hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr>
          
                 <CardBody>
                 <Button onClick={this.openPopupCluster} variant="contained" style={{color:'white', backgroundColor:'green'}} type="submit">View Available Cluster</Button>
                 </CardBody>  
            </CardHeader>
           </Card>
        </Grid> */}
      </Grid>


      <Dialog
        maxWidth={'xs'}
        fullWidth={true} 
        open={true}
        open={this.state.open}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>Available Cluster's Ulb</span></DialogTitle>
        <DialogContent > 
            <div className="create_ulb_content_outer">
                <div className="create_ulb_content_sched">
                    <Grid container spacing={3}>
                       <Grid item xs={12}>
                    { !!this.props.ClusterData&&this.props.ClusterData.map((item)=>{
                    return (
                      <div  style={{display:"flex",padding:'2px'}}>
                        <p style={{textAlign:'start'}}>{item.id}</p> . &nbsp;  <p style={{textAlign:'right'}}>{item.clusterUlbName}</p>
                      </div>
                     
                    )
                    })}
                       </Grid>
                    </Grid>
                </div>
            </div>      
        </DialogContent>
        <DialogActions className="leftp">
            <Button autoFocus onClick={this.handleClose} style={{
                background:'none',
                color:'#3dab35',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }} 
                type="submit">Cancel
            </Button>
        </DialogActions>
    </Dialog>
    </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    data: state.dashboard.dashboard,
    loading: state.loads.loading,
    token: state.auth.token,
    ClusterData: state.ClusterLIstingReducer.clusterData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchDashboardData: (payload) => dispatch(actionsCreators.fetchDashboard(payload)),
    onFetchClusterData: (payload) => dispatch(actionsCreators.fetchClusterData(payload)),
  }
}

export default  connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(CardMain, axios));
